import { Link } from 'react-router-dom';
import Countdown from '@/components/feature/Countdown';
import { SITE_STATS } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full min-h-[660px] md:min-h-[780px] flex items-end overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20abstract%20editorial%20backdrop%20with%20layered%20terracotta%20orange%2C%20deep%20pine%20green%20and%20golden%20amber%20paper%20shapes%2C%20soft%20directional%20light%20and%20depth%2C%20dark%20moody%20edges%2C%20minimal%20artistic%20poster%20texture%2C%20no%20text&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape"
        alt="爆料大赛赛程主视觉背景图"
        title="爆料大赛 2026 赛季赛程主视觉"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>

      <div className="relative w-full px-4 md:px-6 pt-28 md:pt-32 pb-12 md:pb-16">
        <div className="max-w-6xl mx-auto w-full">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-100 text-xs md:text-sm animate-fade-up">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-flashlight-fill text-accent-400"></i>
            </span>
            2026 赛季 · 七阶段赛程已公布
          </span>

          <h1 className="mt-5 md:mt-6 font-heading text-3xl md:text-6xl font-bold text-background-50 leading-tight max-w-4xl animate-fade-up delay-1">
            爆料大赛赛程时间表
            <span className="block text-accent-300 mt-2">活动安排与比赛进度，一页查清</span>
          </h1>

          <p className="mt-5 md:mt-6 max-w-2xl text-sm md:text-base text-background-200 leading-relaxed animate-fade-up delay-2">
            爆料大赛赛程怎么走？时间表、活动安排、比赛进度全在这。从海选到决赛，哪天截稿、哪天开投、哪天出结果，按日程盯紧就行，不用再到处问人。
          </p>

          <div className="mt-8 md:mt-10 flex flex-col lg:flex-row lg:items-end gap-8 lg:gap-14 animate-fade-up delay-3">
            <Countdown tone="dark" />
            <div className="flex flex-wrap gap-3 lg:pb-1">
              <Link
                to="/schedule"
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                查看完整赛程
              </Link>
              <Link
                to="/arrangement"
                className="px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                了解活动安排
              </Link>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto w-full mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-background-50/15 rounded-md overflow-hidden">
          {SITE_STATS.map((s) => (
            <div key={s.label} className="bg-black/30 px-4 md:px-6 py-4 md:py-5">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                {s.value}
                <span className="text-sm md:text-base font-normal text-background-300 ml-1">{s.note}</span>
              </div>
              <div className="mt-1.5 text-xs md:text-sm text-background-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}